import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import {
  ADINSIGHT_LOG_ACTION_TYPE,
  RECOMMENDATION_TYPES,
  getSummaryCardModel,
  APPLY_ACTION_TYPES,
  AUTO_APPLY_TYPES,
  SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

import { SummaryCard } from './summary-card';

const passthroughArray = [
  'dataService',
  'el',
  'viewDetails',
  'reload',
  'scope',
  'readOnly',
  'locationMap',
  'i18n',
  'campaignAdGroups',
  'onFeedbackModalOpen',
  'onDownload',
  'handleHideCard',
  'logOpportunityEvent',
  'currentActivity',
  'guid',
  'permissions',
  'logExpInfo',
  'combineText',
  'adDisplayUrlService',
  'odata',
  'preferencesService',
  'appConfig',
  'showAsyncApplyModal',
  'closeAsyncApplyModal',
  'showApplyConfirmModal',
  'isMCC',
  'overallOptimizationScoreBar',
  'isOptimizationScoreOn',
  'newI18n',
  'isFromDismissTab',
  'isFromSummary',
  'classes',
  'initializeMiniGrid',
  'isAutoApplyRecommendationEnabled',
  'viewSettings',
];

export class SummaryCardList extends React.PureComponent {
  static propTypes = {
    data: PropTypes.shape({
      [RECOMMENDATION_TYPES.BUDGET]: PropTypes.object,
      [RECOMMENDATION_TYPES.COMPETITIVE_BID]: PropTypes.object,
      [RECOMMENDATION_TYPES.DEVICE_BID_BOOST]: PropTypes.object,
      [RECOMMENDATION_TYPES.LOCATION_BID_BOOST]: PropTypes.object,
      [RECOMMENDATION_TYPES.NEW_KEYWORD]: PropTypes.object, // deprecated in Oct 2023
      [RECOMMENDATION_TYPES.NEW_LOCATION]: PropTypes.object,
      [RECOMMENDATION_TYPES.SYNDICATION]: PropTypes.object,
      [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: PropTypes.object,
      [RECOMMENDATION_TYPES.TRENDING_QUERY]: PropTypes.object,
      [RECOMMENDATION_TYPES.GOOGLE_IMPORT]: PropTypes.object,
      [RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED]: PropTypes.object,
      [RECOMMENDATION_TYPES.SITE_LINK]: PropTypes.object,
      [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: PropTypes.object,
      [RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY]: PropTypes.object,
      [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: PropTypes.object,
      [RECOMMENDATION_TYPES.CALLOUT]: PropTypes.object,
      [RECOMMENDATION_TYPES.REPAIR_ADS]: PropTypes.object,
      [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: PropTypes.object,
      [RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS]: PropTypes.object,
      [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: PropTypes.object,
      [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: PropTypes.object,
      [RECOMMENDATION_TYPES.FIX_AD_TEXT]: PropTypes.object,
      [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: PropTypes.object,
      [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: PropTypes.object,
      [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: PropTypes.object,
      [RECOMMENDATION_TYPES.FACEBOOK_IMPORT]: PropTypes.object,
      [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: PropTypes.object,
      [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: PropTypes.object,
      [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: PropTypes.object,
      [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: PropTypes.object,
      [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: PropTypes.object,
      [RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION]: PropTypes.object,
      [RECOMMENDATION_TYPES.PMAX_IMPORT]: PropTypes.object,
      [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: PropTypes.object,
      [RECOMMENDATION_TYPES.SYNDICATION_GAP]: PropTypes.object,
      [RECOMMENDATION_TYPES.AUDIENCE_VIDEOASSET]: PropTypes.object,
    }).isRequired,
    reload: PropTypes.func.isRequired,
    viewDetails: PropTypes.func.isRequired,
    currency: PropTypes.string.isRequired,
    scope: PropTypes.shape({
      levelAt: PropTypes.string.isRequired,
      customerId: PropTypes.string,
      accountId: PropTypes.string,
    }).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    locationMap: PropTypes.func.isRequired,
    logOpportunityEvent: PropTypes.func.isRequired,
    campaignAdGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentActivity: PropTypes.objectOf(PropTypes.any).isRequired,
    context: PropTypes.shape({
      Source: PropTypes.string,
      Level: PropTypes.string.isRequired,
      Category: PropTypes.string,
    }).isRequired,
    permissions: PropTypes.objectOf(PropTypes.any).isRequired,
    perfMarker: PropTypes.shape({
      createChild: PropTypes.func.isRequired,
    }),
    combineText: PropTypes.func,
    adDisplayUrlService: PropTypes.objectOf(PropTypes.any),
    isInlineView: PropTypes.bool,
    odata: PropTypes.PropTypes.shape({
      get: PropTypes.func.isRequired,
    }),
    preferencesService: PropTypes.objectOf(PropTypes.any),
    applyAllCallback: PropTypes.func,
    appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    isMCC: PropTypes.bool,
    isOptimizationScoreOn: PropTypes.bool,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    isFromDismissTab: PropTypes.bool,
    isOverviewPage: PropTypes.bool,
    isAutoApplyRecommendationEnabled: PropTypes.bool.isRequired,
    isAARSection: PropTypes.bool,
  };

  static defaultProps = {
    perfMarker: {
      createChild: () => this,
    },
    combineText: null,
    adDisplayUrlService: null,
    isInlineView: false,
    odata: null,
    preferencesService: null,
    applyAllCallback: _.noop,
    overallOptimizationScoreBar: null,
    isMCC: false,
    isOptimizationScoreOn: false,
    newI18n: {
      getString: _.noop,
    },
    isFromDismissTab: false,
    isOverviewPage: false,
    isAARSection: false,
  };

  constructor(props) {
    super(props);
    this.logImpression();
  }

  componentDidUpdate(prevProps) {
    if (_.has(this.props.context, 'Category') &&
      this.props.context.Category !== prevProps.context.Category) {
      // Category Tab Click log
      this.props.logOpportunityEvent({
        action: ADINSIGHT_LOG_ACTION_TYPE.CLICK_CATEGORY,
        context: _.extend({}, this.props.context, {
          Category: prevProps.context.Category,
          ClickToCategory: this.props.context.Category,
        }),
      });

      this.logImpression();
    }
  }

  componentWillUnmount() {
    const currentCategory = this.props.context.Category;
    const clickToCategory = window.location.pathname.split('/').slice(-1)[0];
    if (this.props && _.has(this.props.context, 'Category') &&
      currentCategory !== clickToCategory) {
      // Category Tab Click log
      this.props.logOpportunityEvent({
        action: ADINSIGHT_LOG_ACTION_TYPE.CLICK_CATEGORY,
        context: _.extend({}, this.props.context, {
          Category: currentCategory,
          ClickToCategory: clickToCategory,
        }),
      });
    }
  }

  logImpression() {
    _.each(this.props.data, (rec, key) => {
      this.props.logOpportunityEvent({
        type: rec.type,
        action: ADINSIGHT_LOG_ACTION_TYPE.IMPRESSION,
        position: _.indexOf(_.keys(this.props.data), key) + 1,
        context: this.props.isAARSection ? _.extend({}, this.props.context, {
          Section: 'AAR',
          ScoreUpLift: rec.optimizationScore,
        }) : _.extend({}, this.props.context, {
          ScoreUpLift: rec.optimizationScore,
        }),
      });
    });
  }

  render() {
    const {
      data,
      i18n,
      currency,
      scope,
      perfMarker,
      currentActivity,
      isOverviewPage,
      permissions,
      isAutoApplyRecommendationEnabled,
      odata,
      newI18n,
    } = this.props;

    const cards = _.chain(data)
      .map((cardData) => {
        let showAutoApplyBanner;
        if (isAutoApplyRecommendationEnabled) {
          showAutoApplyBanner = !isOverviewPage && !this.props.isMCC
            && _.contains(
              _.keys(AUTO_APPLY_TYPES).concat(SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES),
              cardData.type
            )
            && cardData.isAutoApplyOptIn;
        } else {
          showAutoApplyBanner = !isOverviewPage && !this.props.isMCC
          && _.contains(_.keys(AUTO_APPLY_TYPES), cardData.type)
          && permissions.IsRSAAutoApplyEnabled
          && cardData.optInStatus;
        }

        const summaryCardModel = getSummaryCardModel(_.extend({}, cardData, {
          i18n,
          currency,
          scope: scope.levelAt,
          permissions,
          combineText: this.props.combineText,
          adDisplayUrlService: this.props.adDisplayUrlService,
          isMCC: this.props.isMCC,
          isOptimizationScoreOn: this.props.isOptimizationScoreOn,
          currentActivity,
          showAutoApplyBanner,
          isAutoApplyRecommendationEnabled,
          odata,
          newI18n,
        }));

        const childPerfMarker = perfMarker.createChild(summaryCardModel.type);
        return (
          <SummaryCard
            key={cardData.type}
            recommendationsCount={cardData.recommendationsCount}
            opportunityCount={cardData.opportunityCount}
            optimizationScore={cardData.optimizationScore}
            version={cardData.version}
            {...summaryCardModel}
            {..._.pick(this.props, passthroughArray)}
            perfMarker={childPerfMarker}
            isInlineView={this.props.isInlineView}
            context={_.extend(
              {},
              this.props.context,
              { ScoreUpLift: cardData.optimizationScore }
            )}
            callback={(op) => {
              this.props.reload({
                isFromApplyOrDismiss: op.userAction !== APPLY_ACTION_TYPES.UNDISMISS,
              });
              if (op.userAction === APPLY_ACTION_TYPES.ACCEPT) {
                this.props.applyAllCallback();
              }
            }}
            optInStatus={cardData.optInStatus}
            applyDate={cardData.applyDate}
            showAutoApplyBanner={showAutoApplyBanner}
            isAutoApplyOptIn={cardData.isAutoApplyOptIn}
          />
        );
      })
      .value();

    return (
      <div className="recommendation-summary-cards">
        {cards}
      </div>
    );
  }
}
